const answerLabels = {
  yes: "예",
  no: "아니오",
};

export const buildPendingRefinementSituation = (baseSituation, questions = []) => {
  const base = typeof baseSituation === "string" ? baseSituation.trim() : "";
  const additions = (Array.isArray(questions) ? questions : [])
    .map((item) => {
      const question = typeof item?.question === "string" ? item.question.trim() : "";
      const answer = typeof item?.answer === "string" ? item.answer.trim().toLowerCase() : "";
      const label = answerLabels[answer];
      if (!question || !label) return "";
      return `추가 질문: ${question} (답변: ${label})`;
    })
    .filter(Boolean);

  return [base, ...additions].filter(Boolean).join(" ");
};
